<template>
  <div class="brand-box">
    <div class="m-wrapper">
      <div class="m-header"></div>
      <div v-for="(title, index) in columnsM" :key="index" class="m-body">
        <div class="flex-center layout-box">{{ title }}</div>
      </div>
    </div>
    <div class="column" v-for="(column, index) in currentColumns" :key="index">
      <div class="column-title layout-box">{{ column.title }}</div>
      <div class="column-content">
        <div
          class="flex-center"
          v-for="(content, i) in column.contents"
          :key="i"
          :class="[getBoxClass(column.title), {'columns-container': content.columns, 'column-width': content.number === 2}]"
          @mouseover="handleMouseOver(index, i)"
          @mouseleave="handleMouseLeave(index, i)"
          @click="handleClick(index, i)"
          :style="{cursor: useColoredImages ? 'pointer' : '' }"
        >
          <img
            :src="getImageSrc(index, i)"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  useColoredImages?: boolean;
}>();

const router = useRouter();

const columns = [
  { 
    title: '精致', 
    contents: [
      'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-yunkuan1-hover.png',
      'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-qingji-hover.png',
      'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-qingji-mini-hover.png'
    ] 
  },
  { 
    title: '甄选', 
    contents: [
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-kaimanguoji-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-yunfei-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-kaiman-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-xishang-hover.png?v=1'
    ] 
  },
  { 
    title: '经典', 
    contents: [
      'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-yunfeiguoji-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-kaimanbojin-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99youxuan-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99liansuo-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99xinbiao-hover.png'
    ] 
  },
  { 
    title: '自在', 
    contents: [
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-kaimanbieyuan-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-kaimanqingshe-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-aibo-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-aibogongyu-hover.png'
    ] 
  },
  { 
    title: '合悦', 
    contents: [
      'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-zhenxuan-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-jingxuan-hover.png',
      'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-youxuan-hover.png'
    ] 
  }
];

const columnsH = [
  { 
    title: '精致', 
    contents: [
      { url: 'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-yunkuan1.png', path: '/brand-introduction/yunkuan'},
      { url: 'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-qingji.png', path: '/brand-introduction/qingji'},
      { url: 'https://file.40017.cn/zhuketong/workflow/gongsheng/jz-qingji-mini.png', path: '/brand-introduction/qingjiMini'}
    ] 
  },
  { 
    title: '甄选', 
    contents: [
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-kaimanguoji.png'},
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-yunfei.png', path: '/brand-introduction/yunfei'},
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-kaiman.png', path: '/brand-introduction/kaiman'},
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zx-xishang.png?v=1'},
    ] 
  },
  { 
    title: '经典', 
    contents: [
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-yunfeiguoji.png' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-kaimanbojin.png' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99youxuan.png', columns: true, path: '/brand-introduction/99youxuanhotel' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99liansuo.png', columns: true, path: '/brand-introduction/99hotelchain'},
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/jd-99xinbiao.png', columns: true, path: '/brand-introduction/99xinbiaoHotel'}
    ] 
  },
  { 
    title: '自在', 
    contents: [
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-kaimanbieyuan.png' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-kaimanqingshe.png' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-aibo.png', columns: true, number: 2,  path: '/brand-introduction/aimohotel' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/zz-aibogongyu.png', columns: true, number: 2, path: '/brand-introduction/aimoApartment' },
    ] 
  },
  { 
    title: '合悦', 
    contents: [
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-zhenxuan.png', path: '/brand-introduction/unn1' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-jingxuan.png', path: '/brand-introduction/unn2' },
      { url: 'http://file.40017.cn/zhuketong/workflow/gongsheng/hy-youxuan.png', path: '/brand-introduction/unn3' }
    ] 
  }
];

const columnsM = [
  '中高端', '中端', '经济型'
]

const hoveredIndex = ref<{ columnIndex: number | null; contentIndex: number | null }>({ columnIndex: null, contentIndex: null });

const currentColumns = computed(() => (props.useColoredImages ? columnsH : columns));

const getBoxClass = (title: string) => {
  return title === '城市精选' || title === '经济快捷' ? 'layout-box2' : 'layout-box';
};

const handleMouseOver = (columnIndex: number, contentIndex: number) => {
  hoveredIndex.value = { columnIndex, contentIndex };
};

const handleMouseLeave = () => {
  hoveredIndex.value = { columnIndex: null, contentIndex: null };
};

const handleClick = (columnIndex: number, contentIndex: number) => {
  if (props.useColoredImages && columnsH[columnIndex] && columnsH[columnIndex].contents[contentIndex]) {
    const path = columnsH[columnIndex].contents[contentIndex].path;
    router.push(path);
  }
};

const getImageSrc = (columnIndex: number, contentIndex: number) => {
  if (props.useColoredImages && hoveredIndex.value.columnIndex === columnIndex && hoveredIndex.value.contentIndex === contentIndex) {
    return columns[columnIndex].contents[contentIndex];
  }
  return props.useColoredImages ? columnsH[columnIndex].contents[contentIndex].url : columns[columnIndex].contents[contentIndex];
};
</script>

<style scoped lang="scss">
.brand-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: .1875rem;
  box-shadow: 0px 30px 50px rgba(0, 0, 0, 0.15);
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.column .column-title {
  height: 3rem;
  line-height: 3rem;
  font-family: 'Microsoft YaHei';
  font-weight: bold;
  font-size: 1.125rem;
  color: #323232;
  margin-bottom: .1875rem;
}

.m-header {
  height: 3rem;
  line-height: 3rem;
}

.m-body .layout-box {
  color: #999;
}

.layout-box,
.layout-box2 {
  width: 10.1875rem;
  text-align: center;
}

.layout-box {
  height: 5.25rem;
  line-height: 5.125rem;
}

.layout-box2 {
  height: 3.4375rem;
  line-height: 3.4375rem;
}

.column-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .1875rem;
}

.brand-box > .column:last-child {
    img {
      width: 28%;
    }
}

// 为经典和自在类别添加特殊布局
.column {
  &:nth-child(3),
  &:nth-child(4) {
    .column-content {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>
